import React, { Component } from "react";
import Heading from "../Heading.jsx";

class BlogSec extends Component {
  render() {
    return (
      <div>
        <div id="blog" style={{ background: "#111a28" }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <Heading heading={this.props.heading} />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-12">
                <h5 className="text-center text-white">
                  দুঃখিত। এই ওয়েবসাইটে এখন পর্যন্ত কোনো ব্লগ পাবলিশ করা হয় নি।
                </h5>
              </div>
            </div>
          </div>
          <div className="space"></div>
        </div>
      </div>
    );
  }
}

export default BlogSec;
